import { render, staticRenderFns } from "./handDetection.vue?vue&type=template&id=dde52caa&scoped=true"
import script from "./handDetection.vue?vue&type=script&lang=ts"
export * from "./handDetection.vue?vue&type=script&lang=ts"
import style0 from "./handDetection.vue?vue&type=style&index=0&id=dde52caa&prod&lang=scss"
import style1 from "./handDetection.vue?vue&type=style&index=1&id=dde52caa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde52caa",
  null
  
)

export default component.exports